// src/components/ParliamentCards.js
import React from "react";
import "./ParliamentCards.css";
import houseImg from "../assets/backgroundinfo_house_of_representatives.png";
import senateImg from "../assets/backgroundinfo_house_of_representatives.png";
import goverImg from "../assets/backgroundinfo_house_of_representatives.png";

const cardData = [
  {
    title: "House Of Representatives",
    subtitle: "Laws Proposed",
    image: houseImg,
  },
  {
    title: "Senate",
    subtitle: "Review And Check The Law",
    image: senateImg,
  },
  {
    title: "Governor General",
    subtitle: "Final Approval",
    image: goverImg,
  },
];

const ParliamentCards = () => {
  return (
    <div className="parliament-card-wrapper">
      {cardData.map((card, index) => (
        <div className="parliament-card" key={index}>
          <h3>{card.title}</h3>
          <p className="subtitle">{card.subtitle}</p>
          <img src={card.image} alt={card.title} />
        </div>
      ))}
    </div>
  );
};

export default ParliamentCards;
